module.exports = __webpack_public_path__ + "static/media/am-delete.3883c3a2.svg";